export default __webpack_public_path__ + "static/media/MaterialGlass_01.46084ee6.png";